import { Component, Element, Host, Prop, h } from '@stencil/core';

import { IcoButtonStyle } from '../../ui-common/ico-button/ico-button';

@Component({
  tag: 'offer-appointment',
  styleUrl: 'offer-appointment.css',
})
export class OfferAppointment {
  @Element() el: HTMLElement;

  @Prop() appointmentDay: string = '';
  @Prop() appointmentMonth: number;
  @Prop() appointmentTime: string = '';
  @Prop() appointmentYear: string = '';
  @Prop() dayOfWeek: string = '';
  @Prop() isRequestedAppointment: boolean = false;
  @Prop() buttonStyle: IcoButtonStyle = 'primary';
  @Prop() timeFrame: string = '';
  @Prop() whenClicked: Function = () => {};

  private monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  hasScheduled() {
    return this.appointmentDay.length > 0 && this.appointmentTime.length > 0;
  }

  onRequestAppointmentClick() {
    this.whenClicked('onActionClick');
  }

  render() {
    return (
      <Host>
        <div class="py-2 px-0">
          {/* Appointment was already made */}
          {this.isRequestedAppointment && (
            <div class="flex items-center">
              <div class="mr-1">
                <svg-icon icon="circled-check-mark" class="w-6 h-6" />
              </div>
              <div>
                Request Sent: {this.dayOfWeek} {this.timeFrame}
              </div>
            </div>
          )}

          {/* Just scheduled appointment */}
          {this.hasScheduled() && (
            <div class="flex items-center">
              <div class="mr-1">
                <svg-icon icon="circled-check-mark" class="w-6 h-6" />
              </div>
              <div>
                Request Sent: {this.appointmentDay} {this.monthNames[this.appointmentMonth - 1]} {this.appointmentYear} {this.appointmentTime}
              </div>
            </div>
          )}

          {/* Schedule an appointment if user has not made an appointment */}
          {!this.isRequestedAppointment && !this.hasScheduled() && (
            <ico-button
              buttonStyle={this.buttonStyle}
              label="Request Appointment"
              whenClicked={() => {
                this.onRequestAppointmentClick();
              }}
            />
          )}
        </div>
        {/* Dealer has an appointment scheduled */}
      </Host>
    );
  }
}
